export default "__VITE_ASSET__Dfz3SbRQ__"